export default __webpack_public_path__ + "static/4-8d4c9907806dab328f1716945017dd84.png";